module.exports = __webpack_public_path__ + "githubw.png?eb94bb97c3410733ce017b184d314723";


//////////////////
// WEBPACK FOOTER
// ./src/assets/githubw.png
// module id = 15
// module chunks = 0